import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props {
  setOpenDownloadModal: () => void;
}

const DownloadModal = (props: Props) => {
  const { t } = useTranslation(["finessecurity"]);

  return (
    <Mui.Dialog open={true} maxWidth={"md"}>
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center" direction="row" spacing={1}>
          <Mui.Grid item sx={{ display: "flex" }}>
            <MuiIcons.CheckCircle sx={{ color: "green" }} />
          </Mui.Grid>

          <Mui.Grid xs item>
            <Mui.Typography variant="h5">
              {t("blackList.downloadModal.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item sx={{ justifyContent: "flex-end", display: "flex" }}>
            <MuiIcons.Close
              color="disabled"
              fontSize="small"
              onClick={props.setOpenDownloadModal}
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <Mui.Box>{t("blackList.downloadModal.body")}</Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Mui.Grid>
            <Mui.Link href="/finessecurity/watchlistexports">
              {t("blackList.downloadModal.footer")}
            </Mui.Link>
          </Mui.Grid>
          <Mui.Grid
            xs
            item
            sx={{ display: "flex", justifyContent: "flex-end" }}
            pr={2}
          >
            <Mui.Stack direction="row" spacing={2.5}>
              <Mui.Button onClick={props.setOpenDownloadModal}>
                <Mui.Typography variant="h6" color="inherit">
                  {t("buttons.close")}
                </Mui.Typography>
              </Mui.Button>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default DownloadModal;
